import React from 'react';
import { Link } from 'react-router-dom';

const OurServicesSection: React.FC = () => {

    return (
        <section className="home-section-h services-section-h">
        <div className="glass-overlay"></div>
        <div className="services-container-h">
        <div className="home-section-header-h">
        <h2 className="home-section-title-h">Our Services</h2>
            <p className="services-subtitle-h">Comprehensive technology solutions tailored to your needs</p>
          </div>

          <div className="services-grid-h">
            {/* Cloud & Infrastructure */}
            <Link to="/services/cloud-migration" >
            <div className="service-card-h">
              <div className="service-icon-h">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16"></path>
                </svg>
              </div>
              <h3 className="service-title-h">Cloud Migration Strategy</h3>
              <p className="service-description-h">Plan and execute seamless cloud migrations with minimal risk and maximum business value.</p>
              <ul className="service-list-h">
                <li>Cloud Readiness Assessment</li>
                <li>Migrate to AWS, Azure, or GCP</li>
                <li>Application Refactoring & Rehosting</li>
                <li>Risk Mitigation Planning</li>
              </ul>
              <Link to="/services/cloud-migration" className="service-link-h">
                Learn more
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </Link>
            </div> 
            </Link>

            {/* DevOps & Automation */}
            <Link to="/services/ci-cd-services" >
            <div className="service-card-h">
                <div className="service-icon-h">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M20 7h-9"></path>
                    <path d="M14 17H5"></path>
                  </svg>
                </div>
                <h3 className="service-title-h">CI/CD Services</h3>
                <p className="service-description-h">
                  Accelerate delivery with secure, automated CI/CD pipelines for applications, data, and ML models.
                </p>
                <ul className="service-list-h">
                  <li>Multi-Tool CI/CD Expertise</li>
                  <li>GitOps Integration</li>
                  <li>Security & Compliance</li>
                  <li>Automated Testing</li>
                </ul>
                <Link to="/services/ci-cd-services" className="service-link-h">
                  Learn more
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </Link>
              </div>
            </Link>


            {/* Security & Compliance */}
            <Link to="/services/cloud-compliance">
            <div className="service-card-h">
              <div className="service-icon-h">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
              </div>
              <h3 className="service-title-h">Cloud Compliance & Security</h3>
              <p className="service-description-h">
                End-to-end compliance and security solutions with no third-party SaaS. Be audit-ready for SOC 2, HIPAA, ISO 27001, and more.
              </p>
              <ul className="service-list-h">
                <li>SOC 2, ISO 27001, HIPAA</li>
                <li>No SaaS Dependencies</li>
                <li>Automated Evidence Collection</li>
                <li>Git-based Policy Automation</li>
              </ul>
              <Link to="/services/cloud-compliance" className="service-link-h">
                Learn more
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </Link>
            </div>
            </Link>


            {/* cloud- cost -optimization */}
            <Link to="/services/cloud-cost-optimization">
            <div className="service-card-h">
              <div className="service-icon-h">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M9 9h6v6H9z"></path>
                </svg>
              </div>
              <h3 className="service-title-h">Cloud Cost Optimization</h3>
              <p className="service-description-h">Optimize your cloud spend with intelligent strategies that balance performance, scalability, and savings.</p>
              <ul className="service-list-h">
                <li>Cost Visibility & Monitoring</li>
                <li>Right-Sizing Resources</li>
                <li>Auto-Scaling & Scheduling</li>
                <li>Reserved Instance Planning</li>
              </ul>
              <Link to="/services/cloud-cost-optimization" className="service-link-h">
                Learn more
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </Link>
            </div>
            </Link>

          </div>

          <div className="services-footer-h">
            <Link to="/services" className="services-button-h">
              Explore All Services
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </Link>
          </div>
        </div>
        <div className="geometric-shape shape-1"></div>
      <div className="geometric-shape shape-2"></div>
      <div className="geometric-shape shape-3"></div>
      <div className="geometric-shape shape-4"></div>
      </section>
    );
};

export default OurServicesSection;
